import { inject, Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ApplicationService } from '../openapi';
import { Observable, of } from 'rxjs';

@Pipe({
  name: 'application',
  standalone: true
})
export class ApplicationPipe implements PipeTransform {

  private applicationService: ApplicationService = inject(ApplicationService);

  transform(appId?: string | null): Observable<ApplicationAppEntityApplicationRead | null> {
    if (!appId) {
      return of(null);
    } else {
      return this.applicationService.getApplicationItemApplicationItem({ id: appId });
    }
  }

}
